import axios from 'axios';
import React, { useState } from 'react';
import { Button, Form, FormFeedback, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { useAppSelector } from '../../../../../../app/config/store';
import { toast } from 'react-toastify';

const FeedbackModel = props => {
  const [feedback, setFeedback] = useState('');
  const [rating, setRating] = useState<any>([]);
  const [errors, setErrors] = useState<any>({});
  const [loading, setLoading] = useState(false);

  const validateField = () => {
    const errorsObj: any = {};

    if (!rating) {
      errorsObj.rating = 'Please provide your feedback by selecting a rating.';
    }
    if (!feedback.trim()) {
      errorsObj.feedback = 'Please describe your experience.';
    }

    setErrors(errorsObj);
    return Object.keys(errorsObj).length === 0;
  };

  const handleSubmit = async e => {
    e.preventDefault();
    if (!validateField() || loading) return;

    try {
      setLoading(true);

      await axios.post(
        '/api/update-hubspot-feedback',
        {
          rating,
          feedback,
        },

        {
          headers: {
            'Content-Type': 'application/json',
            'Workflow-Authorization': 'Dyhac$25!',
          },
        },
      );

      toast.success('Feedback submitted successfully!', {
        position: 'top-right',
      });

      handleCancel();
    } catch (err) {
      console.error(err);
      toast.error('Something went wrong!', { position: 'top-right' });
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    props?.toggle();
    setRating(null);
    setFeedback('');
    setErrors({});
  };

  return (
    <Modal isOpen={props?.showFeedback} toggle={handleCancel} centered className="custom-modal feedback-modal">
      <ModalHeader toggle={handleCancel}>Share Your Feedback</ModalHeader>

      <ModalBody>
        <Form onSubmit={handleSubmit}>
          {/* Rating */}
          <div className="mb-3">
            <Label>How would you evaluate your overall experience?</Label>
            <div className="d-flex gap-3">
              {[1, 2, 3, 4, 5].map(num => (
                <div
                  key={num}
                  className={`rating-circle ${rating && rating >= num ? 'active' : ''}`}
                  onClick={() => {
                    setRating(num);
                    setErrors(prev => ({ ...prev, rating: '' }));
                  }}
                >
                  {num}
                </div>
              ))}
            </div>
            {errors.rating && <div className="text-danger">{errors.rating}</div>}
          </div>

          {/* Feedback */}
          <FormGroup>
            <Label>How was your experience? We appreciate your feedback.</Label>
            <Input
              type="textarea"
              placeholder="Describe your experience here..."
              style={{ resize: 'none', height: '93px' }}
              value={feedback}
              invalid={!!errors.feedback}
              onChange={e => {
                setFeedback(e.target.value);
                setErrors(prev => ({ ...prev, feedback: '' }));
              }}
            />
            <FormFeedback>{errors.feedback}</FormFeedback>
          </FormGroup>

          <ModalFooter>
            <span className="mb-4">
              You can share a screenshot by emailing it with a quick note to{' '}
              <a href="mailto:info@doyouhaveacase.ai">info@doyouhaveacase.ai</a>.
            </span>

            <Button type="submit" className="download-button" disabled={loading}>
              {loading ? 'Saving...' : 'Save changes'}
            </Button>
          </ModalFooter>
        </Form>
      </ModalBody>
    </Modal>
  );
};

export default FeedbackModel;
